/**
 * The a3s features an asset's hire can grant.
 *
 * A feature is an a3s-side capability. The values are deliberately
 * byte-identical to a3s-reports' `ReportType` strings - `ReportType` derives
 * from this list rather than declaring its own literals, so the two cannot
 * drift and there is no translation layer between them. That identity is what
 * lets Feature eventually REPLACE ReportType at zero cost: report types are
 * persisted in DynamoDB keys and appear in client-API URL paths, so any
 * near-miss spelling here would force a data migration and a URL change.
 *
 * Not to be confused with a Vision Hub hire purpose (`waste_sense`), which is
 * hub vocabulary. That translation is this package's job and has exactly one
 * home: {@link ./hire-purposes.ts}.
 */
export const FEATURES = ["wastesense", "roadsense"] as const;

/** An a3s capability granted by a hire. */
export type Feature = (typeof FEATURES)[number];
